import React, { useEffect, useState, FormEvent, use } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { IModulesPage } from "./types";

import Record from "../../../../components/StudentComponents/Record";
import Payments from "../../../../components/StudentComponents/Payments";
import Inscription from "../../../../components/StudentComponents/Inscription";
import Certification from "../../../../components/StudentComponents/Certification";
import Extraordinary from "../../../../components/StudentComponents/Extraordinary";
import Guarantee from "../../../../components/StudentComponents/Guarantee";
import Incorporation from "../../../../components/StudentComponents/Incorporation";

const StudentDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const token = localStorage.getItem("token");
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true);
  const [studentDetail, setStudentDetail] = useState<any>(null);
  const [grades, setGrades] = useState<any[]>([]);

  const [createRecord, setCreateRecord] = useState(false);
  const [modifyRecord, setModifyRecord] = useState(false);
  const [deleteStudent, setDeleteStudent] = useState(false);
  const [message, setMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [StudentEmail, setStudentEmail] = useState("");
  const [studentName, setStudentName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [canSeeGuide, setCanSeeGuide] = useState("");
  const [address, setAddress] = useState("");
  const [whoSold, setWhosold] = useState("");
  const [sponsor, setSponsor] = useState("");
  const [startDate, setStartDate] = useState("");
  const [modulePrice, setModulePrice] = useState("");
  const [modulesList, setModulesList] = useState<IModulesPage[]>([]);

  const [ineFile, setIneFile] = useState<File | null>(null);
  const [curpFile, setCurpFile] = useState<File | null>(null);
  const [birthCertificate, setBirthCertificate] = useState<File | null>(null);
  const [highSchoolCertificate, setHighSchoolCertificate] = useState<File | null>(null);
  const [welcomeLetter, setWelcomeLetter] = useState<File | null>(null);

  const [showGradeEditor, setShowGradeEditor] = useState(false);
  const [selectedModuleId, setSelectedModuleId] = useState("");
  const [newScore, setNewScore] = useState<number | "">("");

  const privilege = parseInt(localStorage.getItem("privilege") || "0");
  const canModifyRecord = privilege === 1;

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/students/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setStudentDetail(data);
        setStudentName(data.name || "");
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles del estudiante:", error);
        setIsLoading(false);
      });
  }, [id, refreshTrigger]);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/students/progress/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setGrades(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar calificaciones:", error);
        setIsLoading(false);
      });
  }, [id, refreshTrigger]);

  useEffect(() => {
    fetch("https://has-backend-c48d669d897f.herokuapp.com/admin/modules", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setModulesList(data);
        } else {
          console.error("Respuesta inesperada de módulos:", data);
          setModulesList([]);
        }
      })
      .catch((err) => {
        console.error("Error al obtener módulos:", err);
        setModulesList([]);
      });
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("");
    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append("address", address);
    formData.append("phoneNumber", phoneNumber);
    formData.append("whoSold", whoSold);
    formData.append("sponsor", sponsor);
    formData.append("startDate", startDate);
    formData.append("modulePrice", modulePrice);
    formData.append("canSeeGuide", canSeeGuide)

    if (ineFile) formData.append("ine", ineFile);
    if (curpFile) formData.append("curpImage", curpFile);
    if (birthCertificate) formData.append("birthCertificate", birthCertificate);
    if (highSchoolCertificate) formData.append("highSchoolCertificate", highSchoolCertificate);
    if (welcomeLetter) formData.append("welcomeLetter", welcomeLetter);

    try {
        const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/record/${id}/create`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.message || "Error al crear expediente");

        setMessage("Expediente creado con éxito.");
        setRefreshTrigger(prev => prev + 1);
        setCreateRecord(false);
    } catch (err: any) {
        setMessage(err.message);
    }
  };

  const handleUpdate = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("");

    const formData = new FormData();
    formData.append("address", address);
    formData.append("phoneNumber", phoneNumber);
    formData.append("startDate", startDate);
    formData.append("name", studentName);
    formData.append("email", StudentEmail);
    formData.append("modulePrice", modulePrice);
    formData.append("canSeeGuide",canSeeGuide)

    if (ineFile) formData.append("ine", ineFile);
    if (curpFile) formData.append("curpImage", curpFile);
    if (birthCertificate) formData.append("birthCertificate", birthCertificate);
    if (highSchoolCertificate) formData.append("highSchoolCertificate", highSchoolCertificate);
    if (welcomeLetter) formData.append("welcomeLetter", welcomeLetter);

    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/record/${id}/update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Error al actualizar expediente");

      setMessage("Expediente actualizado correctamente.");
      setRefreshTrigger((prev) => prev + 1);
      setModifyRecord(false);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  const handleScoreUpdate = async (e: FormEvent) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch(
        `https://has-backend-c48d669d897f.herokuapp.com/admin/students/${id}/progress/${selectedModuleId}/update-score`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ score: newScore }),
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Error al actualizar calificación");

      setMessage("Calificación actualizada con éxito.");
      setShowGradeEditor(false);
      setRefreshTrigger((prev) => prev + 1);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

const handleDelete = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(
      `https://has-backend-c48d669d897f.herokuapp.com/admin/students/${id}/delete`, 
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al eliminar el estudiante.");
    }

    setDeleteStudent(false); 
    navigate("/admin/students") 

  } catch (error) {
    console.error("Error eliminando al estudiante:", error);
    alert("Hubo un problema al eliminar al estudiante.");
  }
};

  return (
    <div className="min-h-screen w-full px-4 sm:px-8 flex flex-col bg-gray-100">
      <div className="flex-1 overflow-y-auto py-8">
        {isLoading ? (
          <p>Cargando detalles de estudiantes...</p>
        ) : studentDetail ? (
          <div className="flex flex-col items-start gap-8 w-full">
            <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
              <h2 className="font-playfair font-bold text-3xl sm:text-4xl">{studentDetail.name}</h2>
              {canModifyRecord && (
                <div className="flex flex-col sm:flex-row w-full sm:w-1/2 justify-between gap-2">
                  <button onClick={() => setCreateRecord(true)} className="bg-[#1c1c2e] border border-[#8E8E8E] text-white font-sourceSans rounded-lg shadow-lg py-2 px-4 w-full">
                    Crear expediente
                  </button>
                  <button onClick={() => setModifyRecord(true)} className="bg-[#1c1c2e] border border-[#8E8E8E] text-white font-sourceSans rounded-lg shadow-lg py-2 px-4 w-full">
                    Modificar expediente
                  </button>
                  <button onClick={() => setDeleteStudent(true)} className="bg-[red] text-white font-sourceSans rounded-lg shadow-lg py-2 px-4 w-full">
                    Borrar estudiante
                  </button>
                </div>
              )}

            </div>
            {deleteStudent && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-2">
                <div className="bg-[#d9d9d9] w-full max-w-lg h-[30%] p-4 sm:p-6 rounded-lg shadow-lg relative overflow-y-auto ">
                  <button className="absolute top-2 right-2 text-white text-lg" onClick={() => setDeleteStudent(false)}>x </button>
                  <div className="w-full flex flex-col items-center justify-center h-full">
                    <h1 className="text-center text-xl mb-8">¿Estás seguro que deseas borrar al estudiante?</h1>
                    <button className="bg-[red] rounded-lg text-white font-sourceSans w-1/2 shadow-lg py-2" onClick={handleDelete}>
                      Eliminar estudiante
                    </button>
                  </div>
                </div>
              </div>
            )}
            {createRecord && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-2">
                  <div className="bg-[#d9d9d9] w-full max-w-lg h-[90%] p-4 sm:p-6 rounded-lg shadow-lg relative overflow-y-auto">
                    <button className="absolute top-2 right-2 text-white text-lg" onClick={() => setCreateRecord(false)}>x </button>
                    <form onSubmit={handleSubmit}  className=" w-full flex flex-col" action="">
                        <label className="font-sourceSans mb-1">Dirección</label>
                        <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="text" value={address} onChange={(e) => setAddress(e.target.value)}  />
                        <label className="font-sourceSans mb-1">Quien vendió</label>
                        <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="text" value={whoSold} onChange={(e) => setWhosold(e.target.value)}  />
                        <label className="font-sourceSans mb-1">Patrocinador</label>
                        <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="text" value={sponsor} onChange={(e) => setSponsor(e.target.value)}  />
                        <label className="font-sourceSans mb-1">Número de teléfono</label>
                        <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}  />
                        <label className="font-sourceSans mb-1">Fecha de inicio</label>
                        <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}  />
                        <label className="font-sourceSans mb-1">Guia digital o fisica</label>
                        <select className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" value={canSeeGuide} onChange={(e) => setCanSeeGuide(e.target.value)} required>
                          <option value="">Selecciona una opcion</option>
                          <option value="true">Guia digital</option>
                          <option value="false">Guia fisica</option>
                        </select>       
                        <label className="font-sourceSans mb-1">Costo por módulo</label>
                        <select className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" value={modulePrice} onChange={(e) => setModulePrice(e.target.value)} required>
                          <option value="">Selecciona un monto</option>
                          <option value="440">$440</option>
                          <option value="240">$240</option>
                          <option value="190">$190</option>
                          <option value="120">$120</option>
                        </select>
                        <div className="flex flex-wrap">
                            <div className="flex flex-col">
                                <label>INE</label>
                                <input type="file" onChange={(e) => setIneFile(e.target.files?.[0] || null)} required />
                            </div>
                            <div className="flex flex-col">
                                <label>CURP (imagen)</label>
                                <input type="file" onChange={(e) => setCurpFile(e.target.files?.[0] || null)} required />
                            </div>
                            <div className="flex flex-col">
                                <label>Acta de nacimiento</label>
                                <input type="file" onChange={(e) => setBirthCertificate(e.target.files?.[0] || null)} required />
                            </div>
                            <div className="flex flex-col">
                                <label>Certificado de secundaria</label>
                                <input type="file" onChange={(e) => setHighSchoolCertificate(e.target.files?.[0] || null)} required />
                            </div>
                            <div className="flex flex-col">
                                <label>Carta de bienvenida</label>
                                <input type="file" onChange={(e) => setWelcomeLetter(e.target.files?.[0] || null)} required />
                            </div>
                        </div>
                        <div className="w-full flex justify-center">
                        <button className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-1/2 shadow-lg py-2 mt-12" type="submit">
                            Añadir expediente
                        </button>
                        </div>
                    </form>
                </div>
              </div>
            )}
            {modifyRecord && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-2">
                <div className="bg-[#d9d9d9] w-full max-w-lg h-[90%] p-4 sm:p-6 rounded-lg shadow-lg relative overflow-y-auto">
                  <button className="absolute top-2 right-2 text-white text-lg" onClick={() => setModifyRecord(false)}>x</button>
                  <form onSubmit={handleUpdate} className="w-full flex flex-col">
                    <label className="font-sourceSans mb-1">Nombre del estudiante</label>
                    <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 mb-4" type="text" value={studentName} onChange={(e) => setStudentName(e.target.value)} />

                    <label className="font-sourceSans mb-1">Correo del estudiante</label>
                    <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 mb-4" type="text" value={StudentEmail} onChange={(e) => setStudentEmail(e.target.value)} />

                    <label className="font-sourceSans mb-1">Dirección</label>
                    <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 mb-4" type="text" value={address} onChange={(e) => setAddress(e.target.value)} />

                    <label className="font-sourceSans mb-1">Número de teléfono</label>
                    <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 mb-4" type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />

                    <label className="font-sourceSans mb-1">Fecha de inicio</label>
                    <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 mb-4" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                    <label className="font-sourceSans mb-1">Guia digital o fisica</label>
                    <select className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" value={canSeeGuide} onChange={(e) => setCanSeeGuide(e.target.value)}>
                      <option value="">Selecciona una opcion</option>
                      <option value="true">Guia digital</option>
                      <option value="false">Guia fisica</option>
                    </select>
                    <label className="font-sourceSans mb-1">Costo por módulo</label>
                    <select className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" value={modulePrice} onChange={(e) => setModulePrice(e.target.value)} >
                      <option value="">Selecciona un monto</option>
                      <option value="440">$440</option>
                      <option value="240">$240</option>
                      <option value="190">$190</option>
                      <option value="120">$120</option>
                    </select>
                    <div className="flex flex-wrap gap-4">
                      <div className="flex flex-col">
                        <label>INE</label>
                        <input type="file" onChange={(e) => setIneFile(e.target.files?.[0] || null)} />
                      </div>
                      <div className="flex flex-col">
                        <label>CURP (imagen)</label>
                        <input type="file" onChange={(e) => setCurpFile(e.target.files?.[0] || null)} />
                      </div>
                      <div className="flex flex-col">
                        <label>Acta de nacimiento</label>
                        <input type="file" onChange={(e) => setBirthCertificate(e.target.files?.[0] || null)} />
                      </div>
                      <div className="flex flex-col">
                        <label>Certificado de secundaria</label>
                        <input type="file" onChange={(e) => setHighSchoolCertificate(e.target.files?.[0] || null)} />
                      </div>
                      <div className="flex flex-col">
                        <label>Carta de bienvenida</label>
                        <input type="file" onChange={(e) => setWelcomeLetter(e.target.files?.[0] || null)} />
                      </div>
                    </div>

                    <div className="w-full flex justify-center">
                      <button className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-1/2 shadow-lg py-2 mt-12" type="submit">
                        Actualizar expediente
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            <Record refreshTrigger={refreshTrigger} setRefreshTrigger={setRefreshTrigger} />
            <div className="w-full flex flex-row justify-between">
              <h2 className="font-playfair font-bold text-4xl">Calificaciones</h2>
            </div>
            <div className="w-full flex flex-col">
              {isLoading ? (
                  <p className="px-12">Cargando calificaciones...</p>
              ) : grades && grades.length > 0 ? (
                  <>
                  <div className="flex flex-row justify-between px-12 pb-2">
                      <p className="font-bold font-sourceSans">Módulo</p>
                      <p className="font-bold font-sourceSans">Calificación</p>
                  </div>
                  {grades.map((grade, index) => (
                  <div key={index} className="flex flex-row justify-between border-y border-gray-600 px-12 w-full py-2">
                    <a className="font-sourceSans cursor-pointer">
                      {grade.moduleId.title}
                    </a>
                    <div className="flex flex-row gap-4 items-center">
                      <p className="font-sourceSans">
                        {grade.score === null ? "Estudiante está cursando este módulo" : grade.score}
                      </p>
                      {canModifyRecord && (
                        <button
                          onClick={() => {
                            setSelectedModuleId(grade.moduleId._id);
                            setShowGradeEditor(true);
                          }}
                          className="text-sm bg-[#1c1c2e] text-white px-3 py-1 rounded"
                        >
                          Editar
                        </button>
                      )}
                    </div>
                  </div>
                  ))}

                  </>
              ) : (
                  <p className="font-sourceSans px-12">No hay calificaciones disponibles.</p>
              )}
            </div>
            <Inscription />
            <Payments />
            <Guarantee />
            <Extraordinary />
            <Incorporation />
            <Certification />
          </div>
        ) : (
          <p>No se encontró el estudiante.</p>
        )}
      </div>
      {showGradeEditor && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm relative">
            <button
              className="absolute top-2 right-3 text-lg font-bold text-gray-700"
              onClick={() => setShowGradeEditor(false)}
            >
              ×
            </button>
            <h3 className="text-lg font-semibold mb-4">Editar calificación</h3>
            <form onSubmit={handleScoreUpdate} className="flex flex-col gap-4">
              <label htmlFor="score" className="text-sm">Nueva calificación</label>
              <input
                id="score"
                type="number"
                value={newScore}
                onChange={(e) => setNewScore(Number(e.target.value))}
                className="border border-gray-300 px-3 py-2 rounded"
                required
                min={0}
                max={100}
              />
              <button
                type="submit"
                className="bg-[#1c1c2e] text-white rounded py-2 hover:opacity-90"
              >
                Guardar
              </button>
            </form>
          </div>
        </div>
      )}

    </div>
    
  );
};

export default StudentDetailsPage;

